import React from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Image from '../../../../../../Generic/Image';

const Root = styled(Grid)(({ theme }) => ({
	width: '100%',
	display: 'flex',
	gap: '12px',
	alignItems: 'center'
}));

const Img = styled(Image)(({ theme }) => ({
	objectFit: 'cover'
}));

const ImageWrapper = styled(Grid, {
	shouldForwardProp: (prop) => prop !== 'selected'
})(({ theme, selected }) => ({
	width: '10vw',
	height: '10vw',
	padding: '2px',
	borderRadius: '10px',
	border: selected ? `3px solid ${theme.palette.info.main}` : `3px solid #00000000`,
	transition: 'border 0.3s'
}));

const ImageBase = styled(Grid)(({ theme }) => ({
	width: 'calc(10vw - 10px)',
	height: 'calc(10vw - 10px)',
	borderRadius: '5px'
}));

function ThumbnailsGrid({ images, selected, setSelected }) {
	return (
		<Root>
			{images?.map((image) => (
				<ImageWrapper
					key={image?.optimized}
					selected={selected === image?.optimized}
					onClick={() => setSelected(image?.optimized)}
				>
					<ImageBase>
						<Img src={image?.optimized} />
					</ImageBase>
				</ImageWrapper>
			))}
		</Root>
	);
}

export default ThumbnailsGrid;
